import React, { useMemo } from 'react';
import { useSearchOrdersQuery } from '../../../API/order/OrderApi';
import { ordersClosingTomorrowSpecification } from '../../../utilities/pcDashboard/orderSpecifications';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { LoadingSpinnerTW } from '../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';
import { MetricCard } from './MetricCard';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

export const OrdersClosingTomorrow: React.FC = () => {
  const ordersClosingTomorrow = useMemo(() => ordersClosingTomorrowSpecification(), []);

  const {
    data: closingTomorrowData,
    isFetching: closingTomorrowIsFetching,
    error: closingTomorrowError,
  } = useSearchOrdersQuery(ordersClosingTomorrow);
  if (closingTomorrowError) {
    return (
      <div className={'flex-1'}>
        <ErrorMessageTW rtkError={closingTomorrowError} />
      </div>
    );
  }
  return (
    <LoadingSpinnerTW isLoading={closingTomorrowIsFetching}>
      <MetricCard
        href={clientUrls.urlFor.adminOrders(ordersClosingTomorrow)}
        title={'Orders Closing Tomorrow'}
        data={closingTomorrowData?.totalElements ?? 0}
        icon={<CalendarDaysIcon className={'text-white'} />}
        iconClassName={'bg-red-400'}
      />
    </LoadingSpinnerTW>
  );
};
